<empresa tipo='C' titulo="Empresas Clientes" rotaCadastrar='empresasclientes/cadastrar'></empresa>